"use strict";

exports.__esModule = true;
exports.serializer = serializer;
var _domain = require("./serializer/domain");
var _serializer = require("./serializer/serializer");
var _converters = require("./serializer/protobuf-converters/converters");
var _utils = require("./serializer/utils");
const ambassadorConverters = (0, _utils.typeToConverterSet)([..._converters.protobufConverters]);
function serializer(rootSchema, depSchemas = {}) {
  const transform = (0, _serializer.schemaSerializer)(rootSchema, depSchemas, ambassadorConverters);
  return {
    fromJSON(jsonOrString) {
      const jsonOrText = safeJsonParse(jsonOrString) || jsonOrString;
      return transform(jsonOrText, _domain.ConverterType.FROM_JSON);
    },
    toJSON(json) {
      return transform(json, _domain.ConverterType.TO_JSON);
    }
  };
}
function safeJsonParse(someString) {
  try {
    return JSON.parse(someString);
  } catch (error) {}
}
//# sourceMappingURL=ambassador-index.js.map